import React from 'react';

// Modules
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';
import EmailOptInTrigger from 'core/modules/EmailOptInTrigger/EmailOptInTrigger';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import MerchantExperienceComponent from 'core/modules/MerchantExperience/MerchantExperience';
import ErrorMessage from 'core/modules/ErrorMessage/ErrorMessage';

import MerchantExperienceViewSingle from
  'org/modules/MerchantExperience/components/pageViews/MerchantExperienceViewSingle/MerchantExperienceViewSingle';

function MerchantExperience() {
  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <div className="mn_merchantExperience" data-test="MerchantExperience">
          <MerchantExperienceComponent
            // Custom org level sub page component could be passed as an argument to replace the core component
            ViewSingle={MerchantExperienceViewSingle}
          />
          <EmailOptInTrigger />
        </div>
        <ErrorMessage />
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

export default MerchantExperience;
